import { Icons, IconType } from '@ansys-internal/awc-angular/icons';
import { AWFExecute, AWFMenuItem } from '@ansys-internal/awf-angular/core';
import { DriveCycleTableMoreMenu } from './drive-cycle-table-more.menu';
import { ContributionsEnum } from '../../../contributions.enum';

@AWFMenuItem({
  id: ContributionsEnum.DRIVE_CYCLE_MORE_MENU_ITEM,
  menu: DriveCycleTableMoreMenu,
})
export class DriveCycleMoreMenuItem implements AWFExecute {
  type = ContributionsEnum.DRIVE_CYCLE_MORE_MENU_ITEM;
  prefixIcon: IconType = { icon: Icons.MORE };
  tooltip: string = 'More';
  disabled: boolean = false;
  context: any;
  priority: number = 500;
  hidden: boolean = false;

  async execute(): Promise<void> {}
}
